import awaitPeerDependencies from '@ssr/registry';
import { loadEnv } from './load-env';

loadEnv();

const index = translations => {
  return awaitPeerDependencies(['react', 'react-dom', 'react-intl']).then(
    ({ react: React, 'react-dom': ReactDom }) => {
      import(/* webpackChunkName: "app" */ '../../app')
        .then(App => {
          const { __environment__, ...state } = window.SSR_FOOTER_STATE || {};

          ReactDom.hydrate(
            <App.default state={state} translations={translations} />,
            document.getElementById('fragment-footer'),
            () => {
              // css styles are not required anymore once the applications has hydrated
              const tamagoshiSSRStyles = document.getElementById(
                'tamagoshi-ssr-styles-footer',
              );

              if (tamagoshiSSRStyles !== null) {
                tamagoshiSSRStyles.parentNode.removeChild(tamagoshiSSRStyles);
              }
            },
          );
        })
        .catch(e => {
          console.log(e); // eslint-disable-line no-console
        });
    },
  );
};

export { index };
